import { EMPTY, of } from 'rxjs';
import { filter, mergeMap, withLatestFrom } from 'rxjs/operators';
import type { Action } from 'state/actions';
import { dynamicSessionModified, staticSessionModified } from 'state/notification';
import { ScreenMode } from 'state/quoteWorkspace';
import type { EpicWithThunk } from 'state/state.common';
import { sessionSynchronization } from 'utils/streaming/messages';

export function sessionModifiedEpic(): EpicWithThunk {
  return (_action$, state$, { selectors: { getTabIdFromNegotiationId }, streaming }) =>
    sessionSynchronization(streaming).pipe(
      filter(({ type }) => type === 'SessionModified' || type === 'SessionQuoted'),
      withLatestFrom(state$),
      mergeMap(([sessionEvent, state]) => {
        const negotiationId = sessionEvent.negotiationId;
        const { screenMode, tabId } = getTabIdFromNegotiationId(state, negotiationId);
        if (tabId) {
          if (screenMode === ScreenMode.STATIC) {
            return of<Action>(staticSessionModified(tabId, negotiationId));
          } else if (screenMode === ScreenMode.DYNAMIC) {
            return of(dynamicSessionModified(tabId, negotiationId));
          }
        }
        return EMPTY;
      }),
    );
}
